import React from 'react';
import $ from "jquery";

import Title from '../../title';
import Loading from '../../loading';
import Server from '../../../functions/server';
import { Doughnut } from 'react-chartjs-2';
import { Grid } from 'semantic-ui-react';
import LineReport from './LineReport';
import SalesAndPurchase from './SalesAndPurchase';

export default class DashBoardWithChart extends React.Component {

  state = {
    todaySalesDetails: [], yesterSalesDetails: [], thisMonthSalesDetails: [], thisfinacialYearSalesDetails: [],
    colors: []
  }

  componentDidMount() {
    this.salesValue();
  }

  yesterDay(dates, interval) {
    if (interval > 0) {
        dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    x = dates.getFullYear() + "-" + month + "-" + date;
    return x;
}

  getToday() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  startingMonth() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10) { dd = '0' + dd; }
    if(mm < 10) { mm = '0' + mm; }
    let fromMonth = yyyy+'-'+mm+'-01';
    return fromMonth;
  }

  staringFinacialYear() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){
      dd = '0' + dd;
    }
    if (mm < 3) {
      yyyy = yyyy - 1;
    }
    if(mm < 10){
        mm = '0' + mm;
    }
    let fromYear = yyyy+'-04-01';
    return fromYear;
  }

  salesValue() {
    let context = this;
    let today = this.getToday();
    let yesterDay = this.yesterDay(new Date(), 1);
    let startingMonth = this.startingMonth();
    let staringFinacialYear = this.staringFinacialYear();
    let data = { today, yesterDay, startingMonth, staringFinacialYear };
    context.setState({ load: true, message: 'Getting Values' })
    $.ajax({
      type: 'POST', data,
      url: Server() + 'ChartDashboard/SalesDetails.php',
      success: function(data) {
        let todaySalesDetails = []; let yesterSalesDetails = []; 
        let thisMonthSalesDetails = []; let thisfinacialYearSalesDetails = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            if (c.type == 'today') {
              todaySalesDetails.push(c);
            }
            if (c.type == 'yesterday') {
              yesterSalesDetails.push(c);
            }
            if (c.type == 'month') {
              thisMonthSalesDetails.push(c);
            }
            if (c.type == 'year') {
              thisfinacialYearSalesDetails.push(c);
            }
          })
          context.getRandomColor(
            thisfinacialYearSalesDetails, 
            thisMonthSalesDetails, 
            yesterSalesDetails, 
            todaySalesDetails
          );
        } catch (error) {
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
    
  }

  getRandomColor(thisfinacialYearSalesDetails, thisMonthSalesDetails, yesterSalesDetails, todaySalesDetails) {
    let totalColor = thisfinacialYearSalesDetails.length;
    let colors = [];
    let string = '0123456789ABCDEF';
    for (let j = 0; j < totalColor; j++) {
      var letters = thisfinacialYearSalesDetails[j];
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += string[Math.floor(Math.random() * 16)];
      }
      letters.color = color;
      colors.push(color);
    }
    thisfinacialYearSalesDetails.map((d) => {
      thisMonthSalesDetails.map((a) => {
        if (d.name == a.name) { a.color = d.color; }
      })
      yesterSalesDetails.map((b) => {
        if (d.name == b.name) { b.color = d.color; }
      })
      todaySalesDetails.map((c) => {
        if (d.name == c.name) { c.color = d.color; }
      })
    })
    this.setState({ 
      load: false, 
      todaySalesDetails, 
      yesterSalesDetails, 
      thisMonthSalesDetails, 
      thisfinacialYearSalesDetails,
      colors
    })
  }

  getData(datas) {
    let labels = [];
    let total = [];
    let backgroundColor = [];
    datas.map((c) => {
      labels.push(c.name)
      total.push(c.total)
      backgroundColor.push(c.color);
    })
    let data = {
      height: 100,
      datasets: [{
        overalldata: datas,
        data: total,
        backgroundColor
      }],
    };
    return data;
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  makeintoDecimal(value) {
    value = this.convertIntoNumber(value);
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  render() {
    let { todaySalesDetails, yesterSalesDetails, thisMonthSalesDetails, thisfinacialYearSalesDetails } = this.state;
    let todaySales = this.getData(todaySalesDetails);
    let yesterSales = this.getData(yesterSalesDetails);
    let thisMonthSales = this.getData(thisMonthSalesDetails);
    let thisfinacialYearSale = this.getData(thisfinacialYearSalesDetails);
    return (
      <div>
        <Title title={'Vaigai'} openDrawer={this.props.openDrawer}/>
        <Loading load={this.state.load} message={this.state.message} />
        <center style={{marginTop: '1%'}}><h3>SALES REPORT</h3></center>
        <Grid style={{margin: '2%'}}>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Doughnut width={100} height={50} data={todaySales} />
            <center><b>TODAY</b></center>
            { 
              todaySales.datasets.map((c) => {
                 let datas = c.overalldata;
                 return (
                   <table width='100%' id="table">
                     {
                       datas.map((c) => {
                         return (
                           <tr>
                             <td style={{height: 10, width: 20, backgroundColor: c.color}}></td>
                             <td>{c.name}</td>
                             <td style={{textAlign: 'right'}}>{this.makeintoDecimal(c.total)}</td>
                            </tr>
                         )
                       })
                     }
                   </table>
                 )
              })
            }
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Doughnut width={100} height={50} data={yesterSales} />
            <center><b>YESTERDAY</b></center>
            { 
              
              yesterSales.datasets.map((c) => {
                 let datas = c.overalldata;
                 return (
                   <table width='100%' id="table">
                     {
                       datas.map((c) => {
                         return (
                           <tr>
                             <td style={{height: 10, width: 20, backgroundColor: c.color}}></td>
                             <td>{c.name}</td>
                             <td style={{textAlign: 'right'}}>{this.makeintoDecimal(c.total)}</td>
                            </tr>
                         )
                       })
                     }
                   </table>
                 )
              })
            }
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Doughnut width={100} height={50} data={thisMonthSales} />
            <center><b>THIS MONTH</b></center>
            { 
              
              thisMonthSales.datasets.map((c) => {
                 let datas = c.overalldata;
                 return (
                   <table width='100%' id="table">
                     {
                       datas.map((c) => {
                         return (
                           <tr>
                             <td style={{height: 10, width: 20, backgroundColor: c.color}}></td>
                             <td>{c.name}</td>
                             <td style={{textAlign: 'right'}}>{this.makeintoDecimal(c.total)}</td>
                            </tr>
                         )
                       })
                     }
                   </table>
                 )
              })
            }
          </Grid.Column>
          <Grid.Column mobile={16} tablet={16} computer={4}>
            <Doughnut width={100} height={50} data={thisfinacialYearSale} />
            <center><b>THIS YEAR</b></center>
            { 
              
              thisfinacialYearSale.datasets.map((c) => {
                 let datas = c.overalldata;
                 return (
                   <table width='100%' id="table">
                     {
                       datas.map((c) => {
                         return (
                           <tr>
                             <td style={{height: 10, width: 20, backgroundColor: c.color}}></td>
                             <td>{c.name}</td>
                             <td style={{textAlign: 'right'}}>{this.makeintoDecimal(c.total)}</td>
                            </tr>
                         )
                       })
                     }
                   </table>
                 )
              })
            }
          </Grid.Column>
        </Grid>
        { thisfinacialYearSalesDetails.length ?
          <LineReport thisfinacialYearSalesDetails={thisfinacialYearSalesDetails} />:
          ''
        }
        {/* { thisfinacialYearSalesDetails.length ?
          <SalesAndPurchase branch={thisfinacialYearSalesDetails} />:
          ''
        } */}
      </div>
    );
  }

}